import HeicConversionService from '@/services/heicConversionService';

export default {
    async convertImage({commit, getters}, {originalUrl, filename, apiContext}) {
        if (getters.isConverted(originalUrl)) {
            return getters.getConvertedImage(originalUrl);
        }

        if (getters.getConversionStatus(originalUrl) === 'pending') {
            return null;
        }

        commit('SET_CONVERSION_STATUS', {url: originalUrl, status: 'pending'});

        try {
            const convertedUrl = await HeicConversionService.getConvertedImage(
                originalUrl,
                filename,
                apiContext
            );

            if (convertedUrl !== originalUrl) {
                commit('SET_CONVERTED_IMAGE', {originalUrl, convertedUrl});
                commit('SET_CONVERSION_STATUS', {url: originalUrl, status: 'success'});
            }

            return convertedUrl;
        } catch (error) {
            commit('SET_CONVERSION_STATUS', {url: originalUrl, status: 'error'});
            throw error;
        }
    },

    clearConversions({commit}) {
        HeicConversionService.clearCache();
        commit('CLEAR_CONVERTED_IMAGES');
    }
};